// Sticky CTA script for Product Detail Page (PDP)
console.log("Sticky CTA script for PDP loaded.");

// Define the selectors/IDs globally
const STICKY_BAR_ID = 'StickyATCBar';
const ORIGINAL_ATC_CLASS = 'add-to-cart-button';
// Ab wann die Leiste erscheint. Der Wert kommt aus der Sektions-Einstellung
// "Einblenden ab" (data-show-from am #StickyATCBar), damit er pro Seite im
// Theme-Editor gesetzt werden kann. 0 = sofort sichtbar.
// Fehlt das Attribut, bleibt es beim alten Verhalten von 50 %.
const SCROLL_THRESHOLD_FALLBACK_PERCENT = 50;

function getScrollThresholdPercent(stickyBar) {
    const raw = stickyBar ? stickyBar.dataset.showFrom : undefined;
    const parsed = parseFloat(raw);
    return isNaN(parsed) ? SCROLL_THRESHOLD_FALLBACK_PERCENT : parsed;
}

// Selectors for Variant Price/ID Update (FINAL, ROBUST VERSION)
const STICKY_PRICE_ID = 'StickyPrice';
const STICKY_VARIANT_INPUT_ID = 'StickyVariantIDInput';
const MAIN_PRICE_COMPONENT_SELECTOR = 'product-price';
const MAIN_PRICE_CONTENT_SELECTOR = '[ref="priceContainer"]';
const MAIN_PRODUCT_FORM_SELECTOR = '.product-details';


// --- HAUPT-KAUFFORMULAR FINDEN (Aenders 14.08.2026) -------------------------
// Vorher wurde global das ERSTE `product-form-component form` genommen. Auf der PDP
// gibt es aber mehrere (Cross-Sell-Kacheln, Quick-Add-Dialoge) - damit konnte der
// Sticky-Button die Auswahl eines fremden Formulars uebernehmen.
// Anker ist jetzt der Kachel-Picker `.cvp`: dessen Shopify-Section enthaelt garantiert
// das echte Kaufformular des Hauptprodukts.
function findMainProductForm() {
    const picker = document.querySelector('.cvp');
    const section = picker ? picker.closest('.shopify-section') : null;

    if (section) {
        const scoped = section.querySelector('product-form-component form');
        if (scoped) return scoped;
    }

    return document.querySelector('product-form-component form');
}


// --- FUNCTION TO HANDLE VARIANT PRICE AND ID UPDATES USING MUTATION OBSERVER ---
function setupVariantChangeListeners() {
    const stickyPriceElement = document.getElementById(STICKY_PRICE_ID);
    const stickyVariantIDInput = document.getElementById(STICKY_VARIANT_INPUT_ID);
    const mainPriceComponent = document.querySelector(MAIN_PRICE_COMPONENT_SELECTOR);
    const mainPriceContentElement = document.querySelector(MAIN_PRICE_CONTENT_SELECTOR);
    const productFormContainer = document.querySelector(MAIN_PRODUCT_FORM_SELECTOR);

    if (!stickyPriceElement || !stickyVariantIDInput || !mainPriceContentElement || !productFormContainer || !mainPriceComponent) {
        console.error('Sticky ATC: Missing elements for variant update. Check IDs/Selectors.');
        return;
    }

    // Function to perform the price/ID update (runs when MutationObserver detects a change)
    const updateStickyContent = () => {
        // A. Update Variant ID: Update the ID immediately, as this element is usually stable.
        const newVariantInput = productFormContainer.querySelector('[name="id"]');
        if (newVariantInput) {
            stickyVariantIDInput.value = newVariantInput.value;
        }

        // B. Price Update: Introduce a micro-delay (5ms) to wait for the theme's JS to finish writing the final price HTML.
        setTimeout(() => {
            const liveMainPriceElement = document.querySelector(MAIN_PRICE_CONTENT_SELECTOR);
            if (liveMainPriceElement && stickyPriceElement) {
                // Copy the updated HTML content
                stickyPriceElement.innerHTML = liveMainPriceElement.innerHTML;
                console.log('Sticky ATC: Price updated after micro-delay.');
            }
        }, 5);

        console.log('Sticky ATC: Mutation Observer Fired.');
    };

    // 1. Create a MutationObserver instance to watch the stable parent price component
    const priceObserver = new MutationObserver(function(mutationsList, observer) {
        // Run update when content (child list or text) changes on the content element or its descendants
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                updateStickyContent();
                break;
            }
        }
    });

    // 2. Configuration to watch for content changes
    const config = {
        childList: true,
        subtree: true,
        characterData: true
    };

    // 3. Start observing the main price component (the stable wrapper)
    priceObserver.observe(mainPriceComponent, config);

    // Run an initial update immediately to ensure the price and ID are correct on load
    updateStickyContent();
}

// --- CORE FUNCTIONALITY: SCROLL LISTENER & INITIALIZATION ---
function initializeStickyATC(stickyBar) {
    const originalATC = document.getElementsByClassName(ORIGINAL_ATC_CLASS)[0];
    if (!originalATC) {
        console.warn('Sticky ATC: Original ATC button not found, but scroll trigger will still function.');
    }

    console.log('Sticky ATC Bar successfully initialized and ready for scroll events.');

    // Introduce a small delay before setting up the listener
    setTimeout(setupVariantChangeListeners, 50);

    const thresholdPercent = getScrollThresholdPercent(stickyBar);

    function toggleStickyATC() {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;
        const triggerThreshold = viewportHeight * (thresholdPercent / 100);

        // >= statt >, damit 0 % schon ganz oben auf der Seite greift
        if (scrollY >= triggerThreshold) {
            stickyBar.classList.add('show');
        } else {
            stickyBar.classList.remove('show');
        }
    }

    // Attach events
    window.addEventListener('scroll', toggleStickyATC);
    toggleStickyATC(); // Run initial check
}

// --- MUTATION OBSERVER: CODE TO WAIT FOR STICKY BAR TO APPEAR ---
let stickyBarElement = document.getElementById(STICKY_BAR_ID);

if (stickyBarElement) {
    initializeStickyATC(stickyBarElement);
} else {
    console.log('Sticky ATC: Element not found, starting MutationObserver...');

    const observer = new MutationObserver(function(mutations, me) {
        stickyBarElement = document.getElementById(STICKY_BAR_ID);

        if (stickyBarElement) {
            me.disconnect();
            initializeStickyATC(stickyBarElement);
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

// --- FIX 14.08.2026: Varianten-ID UND Abo-Auswahl beim Absenden uebernehmen ------
//
// WICHTIG - das war der eigentliche Fehler vom 29.07.2026:
// Dieser Block stand innerhalb des `else`-Zweiges oben. Er lief damit NUR, wenn die
// Sticky-Leiste beim Skriptstart noch nicht im DOM war. Sobald der Abschnitt sichtbar
// geschaltet war (also im Normalfall), griff der `if`-Zweig - und der submit-Listener
// wurde nie registriert. Deshalb landete trotz ausgewaehltem Spar-Abo immer der
// Einmalkauf im Warenkorb.
//
// Jetzt steht er auf oberster Ebene und laeuft in beiden Faellen.
//
// Der Listener greift in der Capture-Phase, also bevor das Formular abgeschickt wird:
// So entspricht das, was in den Warenkorb geht, immer der aktuell sichtbaren Auswahl
// im Kachel-Picker - unabhaengig davon, was der MutationObserver vorher gesetzt hat.
(function () {
  document.addEventListener('submit', function (event) {
    const stickyForm = event.target;
    if (!(stickyForm instanceof HTMLFormElement)) return;
    if (!stickyForm.classList.contains('sticky-product-form')) return;

    const mainForm = findMainProductForm();
    if (!mainForm) return;

    // Varianten-ID (welche Laufzeit)
    const mainIdInput = mainForm.querySelector('[name="id"]');
    const stickyIdInput = stickyForm.querySelector('[name="id"]');
    if (mainIdInput && stickyIdInput) {
      stickyIdInput.value = mainIdInput.value;
    }

    // Abo-Auswahl (Spar-Abo vs. Einmalkauf)
    const mainPlanInput = mainForm.querySelector('[name="selling_plan"]');
    const stickyPlanInput = stickyForm.querySelector('[name="selling_plan"]');
    if (!stickyPlanInput) return;

    if (mainPlanInput && !mainPlanInput.disabled && mainPlanInput.value) {
      stickyPlanInput.disabled = false;
      stickyPlanInput.value = mainPlanInput.value;
    } else {
      stickyPlanInput.disabled = true;
      stickyPlanInput.value = '';
    }
  }, true);
})();
